<!--工程师界面-->
<template>
    <section>
        <!--工具条-->
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
            <el-form :inline="true" :model="filters">
                <el-form-item>
                    <el-input v-model="filters.masterId" placeholder="工程师ID"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-input v-model="filters.name" placeholder="姓名"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="filters.level" style="width:150px;" clearable placeholder="等级">
                        <el-option
                                v-for="item in level"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item>
                    <el-input v-model="filters.phone" placeholder="手机号码"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-input v-model="filters.storeName" placeholder="店铺名称"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-cascader
                            clearable
                            v-model="filters.regionId"
                            placeholder="地区"
                            :options="provinces"
                            @active-item-change="select_ChangeEvent"
                            :props="props">
                    </el-cascader>
                </el-form-item>


                <el-form-item>
                    <el-button type="primary" v-on:click="getusers">查询</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" v-on:click="add">添加</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" v-on:click="exportExcel">导出工程师余额EXCEL</el-button>
                </el-form-item>
            </el-form>
        </el-col>

        <el-table :data="users" highlight-current-row border stripe v-loading="listLoading"
                  @selection-change="selsChange"
                  style="width: 100%;">

            <el-table-column type="expand">
                <template slot-scope="props">
                    <el-row>

                        <el-col :span="8">
                            <el-form label-position="left" class="demo-table-expand">
                                <el-form-item label="付款账号">
                                    <span>{{ props.row.logistics }}</span>
                                </el-form-item>

                                <el-form-item label="营业时间">
                                    <span>{{ props.row.workTime }}</span>
                                </el-form-item>
                                <el-form-item label="服务类型">
                                    <span>{{ props.row.serviceType | formatServiceType}}</span>
                                </el-form-item>


                                <el-form-item label="备注">
                                    <span>{{ props.row.remark }}</span>
                                </el-form-item>

                            </el-form>
                        </el-col>
                        <el-col :span="8">
                            <el-form label-position="left" class="demo-table-expand">
                                <el-form-item label="图片详情">

                                    <el-button type="success" size="small"
                                               @click="queryImage(props.row)">点击查看
                                    </el-button>

                                </el-form-item>

                                <el-form-item label="经营主体">
                                    <span>{{ props.row.storeInfo }}</span>
                                </el-form-item>
                                <el-form-item label="技能标签">
                                    <span>{{ `${typeof props.row.skills=='undefined'?'':props.row.skillsDesc}` }}</span>
                                </el-form-item>

                            </el-form>
                        </el-col>
                        <el-col :span="8">
                            <el-form label-position="left" class="demo-table-expand">
                                <el-form-item label="等级-积分">
                                    <span>{{ props.row.level | formatLevel}}-{{props.row.score}}</span>
                                </el-form-item>
                                <el-form-item label="面试方式">
                                    <span>{{ props.row.interviewType | formatInterview}}</span>
                                </el-form-item>
                                <el-form-item label="邀请码">
                                    <span>{{ props.row.recommendCode }}</span>
                                </el-form-item>
                                <el-form-item label="详细地址">
                                    <span>{{ props.row.address }}</span>
                                </el-form-item>
                            </el-form>

                        </el-col>
                    </el-row>
                </template>
            </el-table-column>
            <el-table-column prop="masterId" label="ID" width="90">
            </el-table-column>
            <el-table-column prop="storeName" label="店铺名称" >
            </el-table-column>
            <el-table-column prop="phone" label="手机号码" width="130">
            </el-table-column>
            <el-table-column prop="lastLoginTime" label="是否关注" width="100" :formatter="formatLastLoginTime">
            </el-table-column>
            <el-table-column prop="name" label="姓名" width="110">
            </el-table-column>
            <el-table-column prop="level" label="等级" width="120" :formatter="formatLevel">
            </el-table-column>

            <el-table-column prop="joinTime" label="加入时间" width="120">
            </el-table-column>
            <el-table-column prop="regionAddress" label="地区" width="120">
            </el-table-column>

            <el-table-column prop="money" label="余额" width="80" :formatter="formatMoney">
            </el-table-column>
            <el-table-column prop="orderCount" label="订单量" width="80">
                <template slot-scope="scope">
                    <el-button type='info' size="small" :disabled="scope.row.orderCount==0"
                               @click="goInstallOrder(scope.$index, scope.row)">查看:{{scope.row.orderCount}}
                    </el-button>
                </template>

            </el-table-column>

            <el-table-column label="操作" width="180">
                <template slot-scope="scope">
                    <el-button type="text" v-if="accountType==0" size="small"
                               @click="editMoney(scope.$index, scope.row)">修改余额
                    </el-button>
                    <el-button type="text" size="small" @click="goMoneyLog(scope.$index, scope.row)">余额日志</el-button>
                    <el-button type="text" size="small" @click="edit(scope.$index, scope.row)">编辑</el-button>
                    <el-button type="text" style="color:#ff4949" size="small" @click="del(scope.$index, scope.row)">删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <!--工具条-->
        <el-col :span="24" class="toolbar">
            <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="rowCount"
                           :total="total" style="float:right;">
            </el-pagination>
        </el-col>

        <!--图片展示界面-->
        <el-dialog title="查看图片" v-model="queryImageVisible" :close-on-click-modal="false" customClass="customWidth">

            <el-form :model="images" label-width="120px" style="width:100%">
                <el-form-item label="门头相片" v-if="images.doorPic">
                    <img :src="images.doorPic"/>
                </el-form-item>
                <el-form-item label="工位相片" v-if="images.workPic">
                    <img :src="images.workPic"/>
                </el-form-item>
                <el-form-item label="营业执照" v-if="images.licensePic">
                    <img :src="images.licensePic"/>
                </el-form-item>
                <el-form-item label="法人身份证" v-if="images.idCardPic">
                    <img :src="images.idCardPic"/>
                </el-form-item>
            </el-form>

        </el-dialog>


        <!--新增界面-->
        <el-dialog title="新增" v-model="addFormVisible" :close-on-click-modal="false">
            <el-form :model="addForm" label-width="120px" ref="addForm">
                <el-row>

                    <el-col :span="12">
                        <el-form-item label="手机号码" class="require">
                            <el-input v-model="addForm.phone" placeholder='工程师登录账号' auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="店铺名称" class="require">
                            <el-input v-model="addForm.storeName" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="姓名" class="require">
                            <el-input v-model="addForm.name" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="工程师等级" class="require">
                            <el-select v-model="addForm.level" style="width:260px"
                                       placeholder="请选择">
                                <el-option
                                        v-for="item in level"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="12">
                        <el-form-item label="地区" class="require">
                            <el-cascader style="width:260px" clearable
                                         v-model="regionId"
                                         placeholder="请选择省市县"
                                         :options="provinces"
                                         @active-item-change="select_ChangeEvent"
                                         :props="props">
                            </el-cascader>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="详细地址" class="require">
                            <el-input v-model="addForm.address" placeholder="为了精准派单,请输入详细地址"
                                      auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col>
                        <el-form-item label="备注">
                            <el-input type="textarea" v-model="addForm.remark" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>

                </el-row>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="addFormVisible = false">取消</el-button>
                <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
            </div>
        </el-dialog>

        <!--编辑界面-->
        <el-dialog title="编辑" v-model="editFormVisible" :close-on-click-modal="false">
            <el-form :model="editForm" label-width="120px" ref="editForm">
                <el-row>

                    <el-col :span="12">
                        <el-form-item label="手机号码" class="require" prop="phone">
                            <el-input v-model="editForm.phone" placeholder='工程师登录账号' auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="店铺名称" class="require" prop="storeName">
                            <el-input v-model="editForm.storeName" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="姓名" class="require" prop="name">
                            <el-input v-model="editForm.name" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="工程师等级" class="require" prop="level">
                            <el-select v-model="editForm.level" style="width:260px"
                                       placeholder="请选择">
                                <el-option
                                        v-for="item in level"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="12">
                        <el-form-item label="地区" class="require" prop="regionId">
                            <el-cascader style="width:260px" clearable
                                         v-model="regionId"
                                         placeholder="不选择则使用之前地区"
                                         :options="provinces"
                                         @active-item-change="select_ChangeEvent"
                                         :props="props">
                            </el-cascader>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="详细地址" class="require" prop="address">
                            <el-input v-model="editForm.address" placeholder="为了精准派单,请输入详细地址"
                                      auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col>
                        <el-form-item label="备注">
                            <el-input type="textarea" v-model="editForm.remark" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>

                </el-row>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editFormVisible = false">取消</el-button>
                <el-button type="primary" @click.native="editSubmit">提交</el-button>
            </div>
        </el-dialog>

        <!--修改余额-->
        <el-dialog title="修改余额" v-model="editMoneyFormVisible" :close-on-click-modal="false">
            <el-form :model="editMoneyForm" label-width="120px" ref="editMoneyForm">
                <el-form-item label="变动金额" class="require">
                    <el-input v-model="editMoneyForm.changeMoney" placeholder='例:增加3元,输入:3 减少3元,输入:-3'
                              auto-complete="off"></el-input>
                </el-form-item>

                <el-form-item label="修改原因" class="require">
                    <el-input v-model="editMoneyForm.reason" placeholder='请输入修改原因'
                              auto-complete="off"></el-input>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editMoneyFormVisible = false">取消</el-button>
                <el-button type="primary" @click.native="editMoneySubmit">提交</el-button>
            </div>
        </el-dialog>


    </section>
</template>

<script>
    import util from '../../common/js/util'
    import NProgress from 'nprogress'
    import {requestPost} from '../../api/api';
    import {data} from "../../common/data";

    export default {


        data() {
            return {
                accountType: sessionStorage.getItem('type'),
                filters: {
                    masterId: '',
                    name: '',
                    phone: '',
                    regionId: [],
                    storeName: ''
                },
                users: [],
                total: 0,
                rowCount: 20,
                pageNO: 1,
                listLoading: false,
                sels: [],

                provinces: [],

                //查看图片
                queryImageVisible: false,
                images: {},
                addFormVisible: false,
                addLoading: false,
                level: data.level,
                interview: data.interview,
                regionId: [],
                props: {
                    value: 'region_id',
                    label: 'region_name',
                    children: 'cities'
                },
                addForm: {
                    level: '',
                    name: '',
                    phone: '',
                    storeName: '',
                    region: '',
                    address: '',
                    province: '',
                    city: '',
                    area: '',
                    remark: ''
                },
                editFormVisible: false,
                editForm: {
                    masterId: '',
                    level: '',
                    name: '',
                    phone: '',
                    storeName: '',
                    region: '',
                    address: '',
                    province: '',
                    city: '',
                    area: '',
                    remark: ''
                },
                editMoneyFormVisible: false,
                editMoneyLoading: false,
                editMoneyForm: {
                    masterId: '',
                    changeMoney: '',
                    reason: ''
                }
            }
        },

        filters: {
            formatLevel(value) {
                return data.level[value].label
            },
            formatInterview(value) {
                return data.interview[value]
            },
            formatServiceType(value) {
                return data.serviceType[value];
            },
        },


        methods: {
            formatLastLoginTime(row) {
                if (row.lastLoginTime) return '是';
                else return '否';
            },
            formatLevel(row) {
                return data.level[row.level].label;
            },
            formatMoney(row) {
                return row.money / 100;
            },

            formatServiceType(row) {
                return data.serviceType[row.serviceType];
            },

            handleCurrentChange(val) {
                this.pageNO = val;
                this.getusers();
            },

            getusers() {
                let para = {
                    rowCount: this.rowCount,
                    pageNO: this.pageNO
                };

                para = Object.assign(para, this.filters);

                if (para.regionId.length > 0) {
                    para.regionId = para.regionId[2];
                }
                this.listLoading = true;
                NProgress.start();


                let url = 'master/queryPage.do';
                requestPost(this, url, para).then((res) => {
                    if (res != '') {
                        this.total = res.total;
                        this.users = res.data;
                    }
                    this.listLoading = false;
                    NProgress.done();
                });
            },

            getuserById(id) {

                let para = {masterId: id};
                this.listLoading = true;
                NProgress.start();
                let url = 'master/getById.do';
                requestPost(this, url, para).then((res) => {
                    if (res != '') {
                        this.total = 1;
                        this.users.push(res.data);
                    }
                    this.listLoading = false;
                    NProgress.done();
                });
            },

            select_ChangeEvent(val) {

                if (val.length == 1) {
                    util.getArea(this, val[0]).then(res => {
                        this.provinces.map((value, i) => {
                            if (value.region_id === val[0]) {
                                if (!value.cities.length) {
                                    value.cities = res.data.map((value, i) => {
                                        return {
                                            region_id: value.region_id,
                                            region_name: value.region_name,
                                            cities: []
                                        }
                                    })
                                }
                            }
                        })
                    })
                } else if (val.length === 2) {
                    util.getArea(this, val[1]).then(res => {
                        this.provinces.map((value, i) => {
                            if (value.region_id === val[0]) {
                                value.cities.map((value, i) => {
                                    if (value.region_id === val[1]) {
                                        if (!value.cities.length) {
                                            value.cities = res.data.map((value, i) => {
                                                return {
                                                    region_id: value.region_id,
                                                    region_name: value.region_name
                                                }
                                            })
                                        }
                                    }
                                })
                            }
                        })
                    })

                }


            },


            queryImage: function (row) {
                this.queryImageVisible = true;
                //let {doorPic, workPic, licensePic, idCardPic} = row;

                this.images = {
                    doorPic: typeof row.doorPic == 'undefined' ? false : `../image/getByImageId.do?imageId=${row.doorPic}`,
                    workPic: typeof row.workPic == 'undefined' ? false : `../image/getByImageId.do?imageId=${row.workPic}`,
                    licensePic: typeof row.licensePic == 'undefined' ? false : `../image/getByImageId.do?imageId=${row.licensePic}`,
                    idCardPic: typeof row.idCardPic == 'undefined' ? false : `../image/getByImageId.do?imageId=${row.idCardPic}`
                }

            },

            //删除
            del: function (index, row) {
                this.$confirm('确认删除该记录吗?', '提示', {
                    type: 'warning'
                }).then(() => {
                    this.listLoading = true;
                    NProgress.start();
                    let para = {masterId: row.masterId};
                    let url = 'master/del.do';
                    requestPost(this, url, para).then((res) => {
                        this.listLoading = false;
                        NProgress.done();
                        if (res != '') {
                            this.filters.userType = row.userType;
                            util.successTip(this);
                            this.getusers();
                        }
                    });
                }).catch(() => {

                });
            },
            exportExcel:function (index, row) {
                let that = this;
                window.open('master/exportMasterMoney.do?token=' + sessionStorage.getItem('token'));
                //this.$refs.exportEx.submit();


            },

            //显示编辑界面
            edit: function (index, row) {
                this.editFormVisible = true;
                this.editForm = Object.assign({}, row);
                this.regionId = [];
            },

            editMoney: function (index, row) {
                this.editMoneyFormVisible = true;
                this.editMoneyForm.masterId = row.masterId;
            },

            //显示新增界面
            add: function () {
                this.addFormVisible = true;
                this.regionId = [];
            },

            addSubmit: function () {
                this.$refs.addForm.validate((valid) => {
                    if (valid) {
                        this.$confirm('确认提交吗？', '提示', {}).then(() => {
                            this.addLoading = true;
                            NProgress.start();
                            let para = Object.assign({}, this.addForm);
                            para.province = this.regionId[0];
                            para.city = this.regionId[1];
                            para.area = this.regionId[2];
                            let url = 'master/add.do';
                            requestPost(this, url, para).then((res) => {
                                this.addLoading = false;
                                NProgress.done();
                                if (res !== '') {
                                    util.successTip(this);
                                    this.$refs['addForm'].resetFields();
                                    this.addFormVisible = false;
                                    this.filters.phone = this.addForm.phone;
                                    this.getusers();
                                }
                            });
                        });
                    }
                });
            },

            goInstallOrder(index, row) {
                this.$router.push({path: '/installOrder', query: {masterId: row.masterId}})
            },
            goMoneyLog: function (index, row) {
                this.$router.push({path: '/masterMoneyLog', query: {masterId: row.masterId}})
            },

            editMoneySubmit: function () {
                this.$confirm('确认提交吗？', '提示', {}).then(() => {

                    NProgress.start();
                    let para = Object.assign({}, this.editMoneyForm);
                    para.changeMoney = this.editMoneyForm.changeMoney * 100;
                    let url = 'master/updateMoney.do';
                    requestPost(this, url, para).then((res) => {
                        NProgress.done();
                        if (res != '') {
                            util.successTip(this);
                            this.$refs['editMoneyForm'].resetFields();
                            this.editMoneyFormVisible = false;
                            this.getusers();
                        }

                    });
                });
            },


            editSubmit: function () {

                this.$confirm('确认提交吗？', '提示', {}).then(() => {
                    this.editLoading = true;
                    NProgress.start();
                    let para = Object.assign({}, this.editForm);
                    para.province = this.regionId[0];
                    para.city = this.regionId[1];
                    para.area = this.regionId[2];
                    let url = 'master/updateAdmin.do';
                    requestPost(this, url, para).then((res) => {
                        NProgress.done();
                        if (res !== '') {
                            util.successTip(this);
                            this.$refs['editForm'].resetFields();
                            this.editFormVisible = false;
                            this.filters.phone = this.editForm.phone;
                            this.getusers();
                        }
                    });
                });

            },

            selsChange: function (sels) {
                this.sels = sels;
            }

        },

        mounted() {

            if (typeof this.$route.query.masterId !== 'undefined') {
                this.filters.masterId = this.$route.query.masterId;
                this.getusers();
            } else
                this.getusers();
        },
        activated: function () {

        },
        created() {
            let _this = this;
            util.getArea(this, '').then(res => {
                for (let i = 0; i < res.data.length; i++) {
                    this.provinces = res.data;
                    this.$set(this.provinces[i], 'cities', []) // right
                }
            });
        }
    }

</script>


<style scope lang="scss" type="text/scss">
    @import '../../styles/vars.scss';

    img {
        width: 100%;
        height: 500px;
    }

    .customWidth {
        width: 70%

    }
</style>


// WEBPACK FOOTER //
// masterUser.vue?b72dc39a